import { createTheme } from '@mui/material/styles';

const blueLight = '#00303C';
const greenSuccess = '#17873E';

export const theme = createTheme({
  palette: {
    primary: {
      main: blueLight
    },
    secondary: {
      main: '#00303C'
    },
    success: {
      main: greenSuccess
    }
  },
  components: {
    MuiDialogContent: {
      styleOverrides: {
        root: {
          overflowY: 'visible'
        }
      }
    },
    MuiDialog: {
      styleOverrides: {
        paperScrollPaper: {
          overflow: 'visible'
        }
      }
    }
  }
});
